export default "__VITE_ASSET__CIXW22wo__"